import { JobFormManager } from 'jobs/job-form';
import { JobApiService } from 'jobs/JobApiService';
import { JobCountry, JobLocality } from 'jobs/types';
import {
   action,
   computed,
   IReactionDisposer,
   makeObservable,
   observable,
   reaction,
   runInAction,
} from 'mobx';
import { AutocompleteViewModel } from 'shared/components/autocomplete';
import { debounce, DebouncedFunc } from 'lodash';
export class JobLocationViewModel {
   readonly cityVM = new AutocompleteViewModel<JobLocality>(null, {
      getLabel: (loc) => {
         return loc.name;
      },
      onValueChange: (loc) => {
         let value = '';
         if (loc?.id) {
            value = loc.id.toString();
         }
         this.jobManager.form.controls['city'].setValue(value);
      },
   });

   readonly cities = observable.array<JobLocality>([], { deep: true });
   disposers: IReactionDisposer[] = [];
   private _debouncedGetCities: DebouncedFunc<(query: string) => Promise<void>>;
   constructor(public readonly jobManager: JobFormManager) {
      makeObservable(this, {
         countries: computed,
      });
      this._debouncedGetCities = debounce((query) => this.getCities({ query }), 500);
   }

   onSearch(query: string): void {
      this._debouncedGetCities(query);
   }

   getCities = async ({ query }: { query: string }): Promise<void> => {
      if (query.length > 1) {
         try {
            const res = await JobApiService.localitySearch({
               query: query,
               country_id: Number(this.jobManager.form.controls['country'].value),
            });
            if (res.status === 200) {
               runInAction(() => {
                  this.cities.replace(res.response);
               });
            }
         } catch (e) {}
      }
   };

   get countries(): JobCountry[] {
      const jobAttr = this.jobManager.jobAttributes.get();
      if (jobAttr) {
         return jobAttr.countries;
      }
      return [];
   }

   dispose(): void {
      this.disposers.forEach((d) => d());
   }
}
